import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'

import { IRadioAutoArgumentsStory } from './AutoStoryArticleContain.props'

import './AutoStoryArticleContent.scss'

const AutoStoryArticleRadio: FC<{ storyProperties: IRadioAutoArgumentsStory }> = ({ storyProperties }) => (
  <div className="auto-story-stream">
    {storyProperties.weeks.map((week, idx) => (
      <div className="auto-story-stream__column" key={idx}>
        <div className="auto-story-stream__title">
          <Icon name="calendar-days" className="auto-story-stream__icon" />
          <h5>CW {week.radio_spins_calendar_week_num}</h5>
        </div>
        {week.stations.map((station, index) => (
          <div className="auto-story-stream__playlist" key={station.radio_spins_station_name + index}>
            {station.radio_spins_station_name}&nbsp;
            {station.radio_spins_country_id && `[${station.radio_spins_country_id}]`} -&nbsp;
            {station.radio_spins_ppw_count} ppw {station.radio_spins_up}
          </div>
        ))}
      </div>
    ))}
  </div>
)

export default AutoStoryArticleRadio
